import { Switch } from '@patrianna/core-components'
import { nextTick } from '@patrianna/shared-utils'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { ThemeLightDark } from '@patrianna-icons/material-icons'
import { type FC } from 'react'

import content from 'prismic-translates/common.json'
import { useThemeContext } from 'theme/themeProvider'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

const MenuLinkDarkThemeSwitch: FC<{ handleTrackEvent: (name: string) => void }> = ({ handleTrackEvent }) => {
  const { isDarkMode, changeThemeMode } = useThemeContext()

  const handleClick = () => {
    nextTick().then(() => {
      changeThemeMode()
      handleTrackEvent('dark_theme')
    })
  }

  return (
    <div className={classes.root} onClick={handleClick}>
      <ThemeLightDark />
      <span className={classes.text}>{t('dark_theme')}</span>

      <Switch checked={isDarkMode} onChange={() => {}} value='darkTheme' color='primary' />
    </div>
  )
}

export default MenuLinkDarkThemeSwitch
